import React from 'react';

export const JAFlagArt: React.FC = () => (
  <>
    <circle cx="10" cy="10" r="10" fill="#FFFFFF" />
    <circle cx="10" cy="10" r="6" fill="#BC002D" />
  </>
);

JAFlagArt.displayName = 'JAFlagArt';
